export default __webpack_public_path__ + "static/media/pomian.f118339e.png";